import { combineDataProviders } from "react-admin";

import dataProviderRules from "./rules";
import { RULES, RULES_DEEMED_SUPPLIER } from "./resources";

const dataProvidersMap = {
  [RULES]: dataProviderRules,
  [RULES_DEEMED_SUPPLIER]: dataProviderRules,
};

const dataProvider = combineDataProviders((resource) => {
  // @ts-expect-error way too complex to match expected type of React Admin
  const dataProvider = dataProvidersMap[resource];
  if (!dataProvider) {
    throw new Error(`Unknown resource: ${resource}`);
  }
  return dataProvider;
});

export default dataProvider;
